// @ts-strict-ignore
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ElementRef,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { FormData, FormSubmitted } from '../../../models/form-data.model';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage.service';
import { ZuulError } from 'src/app/models/zuul-error.model';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.scss',
})
export class DynamicFormComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @Input() public error: ZuulError;
  @Input() public success: any = {};
  @Input() public buttonText: string;
  @Input() public lightTheme: boolean;
  @Input() public formData: FormData[];
  @Input() public reset: boolean;
  public timeToWait: number = null;
  public errorMessage: string;
  public counter: any;
  public codeState = false;
  public showGetCode = false;
  public form: UntypedFormGroup;
  public tooltipControlName = '';
  public remeberUserEmail = false;
  @Output() public readonly submitted: EventEmitter<FormSubmitted> =
    new EventEmitter<FormSubmitted>();
  @Output() public readonly newCode = new EventEmitter<string>();
  @Output() public readonly remeberMeToggle = new EventEmitter<boolean>();
  @ViewChild('loginInput') public loginInput: ElementRef;
  @ViewChild('rememberMeSlideToggle')
  public rememberMeSlideToggle: MatSlideToggle;

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly notificationsService: NotificationsService,
  ) {}

  public ngOnInit(): void {
    const formGroup: any = {};

    this.formData.forEach((formControl) => {
      formGroup[formControl.controlName] = new UntypedFormControl('');
    });
    this.form = new UntypedFormGroup(formGroup);
  }

  public ngAfterViewInit(): void {
    if (this.localStorageService.get('storedEmail') && !this.codeState) {
      this.rememberMeSlideToggle.checked = true;
      this.loginInput.nativeElement.focus();
      this.remeberUserEmail = true;
      this.remeberMeToggle.emit(this.remeberUserEmail);
      setTimeout(() => {
        this.form
          .get('email')
          .setValue(this.localStorageService.get('storedEmail'));
        this.form.markAsDirty();
        this.form.updateValueAndValidity();
      }, 200);
    } else {
      this.loginInput.nativeElement.focus();
    }
  }

  public ngOnChanges(): void {
    if (this.form) {
      this.form.enable();
    }
    if (this.reset) {
      this.form.reset();
      this.reset = false;
    }
    if (this.error) {
      this.showError(this.error);
      this.openSnackbarFailure();
    }
    if (this.success) {
      if (this.success.showResendCodeOption) {
        this.codeState = true;
        this.setTimeToWait(this.success.timeToWait);
        setTimeout(() => {
          this.openSnackbarSuccess();
        }, 500);
      }
    }
  }

  public setTimeToWait(timeToWait: number): void {
    this.timeToWait = timeToWait * 60 * 1000;
    this.counter = setInterval(this.timer.bind(this), 1000);
  }

  public timer(): void {
    this.timeToWait = this.timeToWait - 1000;
    if (this.timeToWait <= 0) {
      clearInterval(this.counter);
    }
  }

  public requestNewCode(message: string): void {
    this.success = null;
    clearInterval(this.counter);
    this.newCode.emit(message);
  }

  public submitForm(): void {
    const emittedObj: FormSubmitted = {};

    this.form.disable();
    this.formData.forEach((row) => {
      emittedObj[row.controlName] = this.form.get(row.controlName).value;
    });
    this.submitted.emit(emittedObj);
  }

  public remeberMe(event: MatSlideToggleChange): void {
    this.remeberUserEmail = event.checked;
    this.remeberMeToggle.emit(this.remeberUserEmail);
  }

  public trackByIndex(index: number): number {
    return index;
  }

  public showError(error: ZuulError): void {
    this.errorMessage = error.message;
  }

  public openSnackbarFailure(): void {
    this.notificationsService.openSnackbar({
      data: { message: this.errorMessage },
      panelClass: 'snackbar-fail',
    });
  }

  public openSnackbarSuccess(): void {
    this.notificationsService.openSnackbar({
      data: { message: this.success.message },
    });
  }

  public ngOnDestroy(): void {
    clearInterval(this.counter);
  }
}
